
import { defineComponent, PropType, computed } from "vue";
import { GroupedAlert } from "@/stores/telegramAlerts";
import SportsAlertRow from "@/components/alerts/tables/SportsAlertRow.vue";

export default defineComponent({
  name: "SportsAlertsTable",
  components: {
    SportsAlertRow,
  },
  props: {
    alerts: {
      type: Array as PropType<GroupedAlert[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    expandedAlertId: {
      type: Object as PropType<Set<string>>,
      required: true,
    },
    editingAlertId: String as PropType<string | null>,
    isSaving: Boolean,
    isReprocessing: Object as PropType<Record<number, boolean>>,
  },
  emits: [
    "toggle-expand",
    "start-edit",
    "cancel-edit",
    "save-edit",
    "reprocess-message",
  ],
  setup(props) {
    // Compute sorted stakes for consistent color assignment
    const sortedStakes = computed(() => {
      const uniqueStakes = new Set<string>();
      props.alerts.forEach((alert) => {
        if (alert.stake) {
          uniqueStakes.add(alert.stake);
        }
      });
      return Array.from(uniqueStakes).sort(
        (a, b) => parseFloat(a) - parseFloat(b)
      );
    });

    return {
      sortedStakes,
    };
  },
});
